import { NgModule } from '@angular/core';
import { GoAppsCommunModule } from './common-mobile-apps.module';
import { environment } from 'src/environments/environment';
import { Printer } from '@awesome-cordova-plugins/printer/ngx';

@NgModule({
  declarations: [],
  imports: [GoAppsCommunModule],
  providers: [Printer],
})
export class GoAdminAppModule {}

export const goAdminAppImports =
  environment.mode === 'Admin' ? [GoAdminAppModule] : [];
